<template>
  <div class="wrap sunsim-legacy-styles">

    <div class="container_">
      <div class="header">
        <div class="top-line">
          <div class="container">
            <div class="row width-fix regions-list-wrapper">
              <div class="txt col-sm-4 col-xs-12">Отдел продаж:&nbsp; <a class="js-adv-num js-href-tel format-full-7"
                                                                         href="tel:+74951010495">+7-495-10-10-495</a>
              </div>
              <div class="txt col-sm-5 col-xs-12">
							<span class="adv-hide">
								<a href="https://wa.me/74950909495" target="_blank" class="header-link tdn">
									<img src="../assets/images/wa.png">
								</a>
								Отдел поддержки:&nbsp;
							</span>
                <a class="adv-hide" href="tel:+74950909495">+7-495-09-09-495</a></div>
              <div class="txt col-sm-3 col-xs-12 pull-right text-right">
                <a href="https://www.sunsim.ru/">На сайт СанСим</a>
              </div>
            </div>
          </div>
        </div>

        <nav id="main-navbar" class="navbar navbar-default navbar-main
				navbar-expand-lg navbar-light bg-grey">
          <div class="container">
            <a class="navbar-brand navbar-main-logo" href="https://www.sunsim.ru"><img
                src="../assets/images/logo.png"></a>

            <button type="button" class="navbar-toggler collapsed" data-toggle="collapse" data-target="#navbar-main"
                    aria-expanded="false">
              <span class="navbar-toggler-icon"></span>
            </button>


            <div class="collapse navbar-collapse justify-content-end" id="navbar-main">
              <ul class="navbar-nav">
                <li class="nav-item">
                  <a class="js-open-submenu not-link nav-link" href="#">Виртуальная АТС&nbsp;<span class="caret"></span></a>
                  <ul class="dropdown-submenu">
                    <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/virtual-ats">О продукте</a>
                    </li>
                    <li class="nav-item">
                      <a class="js-open-submenu not-link nav-link" href="#">Функции Виртуальной АТС&nbsp;<span
                          class="caret"></span></a>
                      <ul class="dropdown-submenu">
                        <li class="nav-item"><a class="nav-link"
                                                href="https://www.sunsim.ru/services/calls-distribution">Распределение
                          вызовов</a></li>
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/services/audio-notify">Аудиосервисы</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/services/short-numbers">Короткие
                          номера</a></li>
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/services/zapis-razgovorov">Запись
                          разговоров</a></li>
                      </ul>
                    </li>
                    <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/virtual-ats">Тарифы</a></li>
                    <li class="nav-item">
                      <a class="js-open-submenu not-link nav-link" href="#">Бизнес-функции&nbsp;<span
                          class="caret"></span></a>
                      <ul class="dropdown-submenu">
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/services/calltracking">Коллтрекинг</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/services/callback-widget">Виджет
                          обратного звонка</a></li>
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/services/integrations">Сервисы
                          интеграции</a></li>
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/services/amocrm">Интеграция
                          с amoCRM</a></li>
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/services/bitrix24">Интеграция
                          с CRM Битрикс24</a></li>
                      </ul>
                    </li>
                    <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/pages/yatelephony">Партнерство
                      с Яндекс.Телефонией</a></li>
                  </ul>
                </li>
                <li class="nav-item">
                  <a class="nav-link js-open-submenu not-link" href="#">Номера&nbsp;<span class="caret"></span></a>
                  <ul class="dropdown-submenu">
                    <li class="nav-item">
                      <a class="nav-link js-open-submenu not-link" href="#">Городские номера&nbsp;<span
                          class="caret"></span></a>
                      <ul class="dropdown-submenu">
                        <li class="nav-item"><a class="nav-link"
                                                href="https://www.sunsim.ru/numbers?prefixes%5B0%5D=495">Номера 495</a>
                        </li>
                        <li class="nav-item"><a class="nav-link"
                                                href="https://www.sunsim.ru/numbers?prefixes%5B0%5D=499">Номера 499</a>
                        </li>
                      </ul>
                    </li>
                    <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/numbers?prefixes%5B0%5D=800">Номера
                      8800</a></li>
                  </ul>
                </li>
                <li class="nav-item">
                  <a class="nav-link js-open-submenu not-link" href="#">Тарифы&nbsp;<span class="caret"></span></a>
                  <ul class="dropdown-submenu">
                    <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/virtual-ats">Виртуальная
                      АТС</a></li>
                    <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/main/virtual-number">Городские
                      номера</a></li>
                    <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/ip-telephony">SIP-телефония</a>
                    </li>
                    <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/number8800">Номера 8-800</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link js-open-submenu not-link" href="#">Архив&nbsp;<span class="caret"></span></a>
                      <ul class="dropdown-submenu">
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/virtual-ats/archive">Виртуальная
                          АТС</a></li>
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/virtual-number/archive">Городские
                          номера</a></li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li class="nav-item">
                  <a class="nav-link js-open-submenu not-link" href="#">SIP-оборудование&nbsp;<span
                      class="caret"></span></a>
                  <ul class="dropdown-submenu">
                    <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/shop">Магазин</a></li>
                    <li class="nav-item">
                      <a class="nav-link js-open-submenu not-link" href="#">Обрудование&nbsp;<span class="caret"></span></a>
                      <ul class="dropdown-submenu">
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/shop/catalog/ip-phones">IP-телефоны</a>
                        </li>
                        <li class="nav-item"><a class="nav-link"
                                                href="https://www.sunsim.ru/shop/catalog/ip-ats">IP-АТС</a></li>
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/shop/catalog/headset">Гарнитуры</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/shop/catalog/voip-gateway">VoIP-шлюзы
                          Yeastar</a></li>
                      </ul>
                    </li>
                    <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/shop/pages/services">Услуги</a>
                    </li>
                    <li class="nav-item"><a class="nav-link"
                                            href="https://www.sunsim.ru/shop/pages/pay-delivery">Оплата</a></li>
                  </ul>
                </li>
                <li class="nav-item">
                  <a class="nav-link js-open-submenu not-link" href="#">Поддержка&nbsp;<span class="caret"></span></a>
                  <ul class="dropdown-submenu">
                    <li class="nav-item">
                      <a class="nav-link js-open-submenu not-link" href="#">Куда обратиться&nbsp;<span
                          class="caret"></span></a>
                      <ul class="dropdown-submenu">
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/support">Поддержка клиентов
                          24/7</a></li>
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/contacts">Офисы</a></li>
                      </ul>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link js-open-submenu not-link" href="#">Самообслуживание&nbsp;<span
                          class="caret"></span></a>
                      <ul class="dropdown-submenu">
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/personal">Личный
                          кабинет</a></li>
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/mobile">Мобильное
                          приложение</a></li>
                      </ul>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link js-open-submenu not-link" href="#">Обслуживание и настройки&nbsp;<span
                          class="caret"></span></a>
                      <ul class="dropdown-submenu">
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/how-to-connect">Как
                          подключиться</a></li>
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/instruction">Настройка
                          ВАТС</a></li>
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/docs">Бланки заявлений</a>
                        </li>
                      </ul>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link js-open-submenu not-link" href="#">Правовая информация&nbsp;<span
                          class="caret"></span></a>
                      <ul class="dropdown-submenu">
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/licenses">Лицензии</a></li>
                        <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/docs">Условия</a></li>
                      </ul>
                    </li>
                    <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/faq">FAQ</a></li>
                    <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/frauders">Борьба с
                      мошенниками</a></li>
                    <!--<li class="nav-item"><a class="nav-link" href="/sunsim_lk/www/pages/review">Поделитесь своим мнением</a></li>-->
                  </ul>
                </li>
                <li class="nav-item">
                  <a class="nav-link js-open-submenu not-link" href="#">Оплата&nbsp;<span class="caret"></span></a>
                  <ul class="dropdown-submenu">
                    <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/pay">Как оплатить</a></li>
                    <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/pay/show">Счёт на оплату</a>
                    </li>
                    <li class="nav-item"><a class="nav-link" href="https://www.sunsim.ru/pay/sbol">Сбербанк Онлайн</a>
                    </li>
                  </ul>
                </li>
              </ul>


            </div>
          </div>

        </nav>


      </div>

      <div class="login-content">
        <slot name="content"></slot>
      </div>

      <login-footer/>
    </div>
  </div>

</template>

<script>

import LoginFooter from "@/layouts/components/LoginFooter";
document.addEventListener('click', function (e) {
  var selector = '.js-open-submenu';

  if (e.target.closest(selector) != null) {
    e.preventDefault();

    if (window.matchMedia('(max-width: 767px)').matches) {
      var parent_link = e.target.closest(selector);
      parent_link.parentElement.querySelector('.dropdown-submenu').classList.toggle('dropdown-submenu__open');
    }
  }
});

export default {
  name: 'LoginLayout',
  components: {LoginFooter},
}
</script>

<style scoped lang="less">

@import "../assets/less/header-footer.less";

.container_ {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

@-moz-keyframes marquee {
  0% {
    transform: translateX(70%);
  }
  100% {
    transform: translateX(-70%);
  }
}

@-webkit-keyframes marquee {
  0% {
    transform: translateX(70%);
  }
  100% {
    transform: translateX(-70%);
  }
}

@keyframes marquee {
  0% {
    -moz-transform: translateX(70%);
    -webkit-transform: translateX(70%);
    transform: translateX(70%)
  }
  100% {
    -moz-transform: translateX(-70%);
    -webkit-transform: translateX(-70%);
    transform: translateX(-70%);
  }
}

.yandex_telephony_marquee {
  background-color: #f15a29;
  font-weight: bold;
  font-size: 24px;
  color: #fff;
  padding: 15px 0;
  line-height: 30px;
  text-align: center;
  overflow: hidden;
}

.yandex_telephony_marquee p {
  -moz-animation: marquee 20s linear infinite;
  -webkit-animation: marquee 20s linear infinite;
  animation: marquee 20s linear infinite;
  margin: 0;
}

a, a:hover, a:visited, a:focus, a:link {
  text-decoration: none
}

.sunsim-legacy-styles {
  margin-top: -20px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; /** Для шапки пока старое */
  font-size: 14px;

  #main-navbar {
    .dropdown-submenu {
      li {
        a {
          &.not-link {
            &:hover {
              border: none;
            }
          }
        }
      }
    }

    .navbar-main-logo {
      margin-top: 0;
    }

    &.navbar {
      padding-top: 0;
      padding-bottom: 0;

      .navbar-collapse {
        transition: all 0.15s;
      }

      .navbar-nav {
        & > li {
          & > .nav-link {
            padding: 19px 20px;
            border-bottom: 2px solid transparent;
            font-size: 16px;
            line-height: 20px;

            &:hover {
              border-color: #00c4ff;
            }
          }
        }

        & > li {
          & > .dropdown-submenu {
            li {
              a {
                padding: 5px 24px;
              }
            }
          }
        }
      }
    }

    .navbar-toggler {
      margin: 7px 0;
    }

    .caret {
      display: inline-block;
      width: 0;
      height: 0;
      margin-left: 2px;
      vertical-align: middle;
      border-top: 4px dashed;
      border-top: 4px solid \9;
      border-right: 4px solid transparent;
      border-left: 4px solid transparent;
    }
  }
}
</style>
